// Import React and Hooks
import React, { useEffect, useState } from 'react'
// Import React Router Dom
import { useLocation } from 'react-router-dom'
// Import Redux and Hooks
import { useAppSelector } from '../../hooks/useRedux'



const BackgroundVideo = () => {



  // Use State
  const [ idVideo, setIdVideo ] = useState('')



  // Use location
  const location = useLocation()



  // Use Effect
  useEffect( () => {
    setIdVideo( location.pathname === '/cempasuchil/ofrendas-vivas' ? '750373807?h=62204d47c0' : '750373807?h=62204d47c0' )
  }, [location] )



  // Use selector
  const background = useAppSelector( state => state.background )



  return (
    <section className={`backgroundVideo ${ !background.isVideoVisible ? 'hidden' : null } `}>
      <iframe src={`https://player.vimeo.com/video/${idVideo}&title=0&byline=0&portrait=0&background=1&loop=true&quality=1080p`} width="16" height="9" allow="autoplay; fullscreen; picture-in-picture" className="backgroundVideo__iframe" />
    </section>
  )
}



export default BackgroundVideo
